export default "__VITE_ASSET__Bku2ia0n__"